import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-cards.css';
import { UitkCardTags, UitkCardAspectRatios, UitkCardBackgroundThemes } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkCard = React.forwardRef(function (props, ref) {
    var _a, _b;
    var _c = props.backgroundTheme, backgroundTheme = _c === void 0 ? UitkCardBackgroundThemes.PRIMARY : _c, border = props.border, children = props.children, className = props.className, overflow = props.overflow, padded = props.padded, placeholder = props.placeholder, selected = props.selected, tag = props.tag, style = props.style, attributes = __rest(props, ["backgroundTheme", "border", "children", "className", "overflow", "padded", "placeholder", "selected", "tag", "style"]);
    var actionArea;
    var featuredHeader;
    var link;
    var placeholderChild;
    var newChildren = [];
    var Tag = ((tag && UitkCardTags.get(tag)) || UitkCardTags.get('div'));
    var childrenArray = React.Children.toArray(children);
    // Map through the children and place the ones we want in specific places
    React.Children.forEach(children, function (child) {
        var _a;
        if (!child) {
            return;
        }
        switch ((_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) {
            case 'UitkCardActionArea':
                actionArea = child;
                break;
            case 'UitkCardFeaturedHeader':
                featuredHeader = child;
                break;
            case 'UitkCardLink':
                link = child;
                break;
            case 'UitkCardPlaceholder':
                placeholderChild = child;
                break;
            default:
                newChildren.push(child);
        }
    });
    var baseClass = 'uitk-card';
    var ratioClass = placeholder && UitkCardAspectRatios.get(placeholder.aspectRatio);
    var isValidUitkCardBackgroundTheme = function (value) {
        return Object.values(UitkCardBackgroundThemes).includes(value);
    };
    var backgroundClassFragment = backgroundTheme && isValidUitkCardBackgroundTheme(backgroundTheme)
        ? backgroundTheme
        : UitkCardBackgroundThemes.PRIMARY;
    var cssClassNames = getClassNameList(baseClass, "".concat(baseClass, "-roundcorner-all"), actionArea && "".concat(baseClass, "-has-action-area"), border && "".concat(baseClass, "-has-border"), placeholder && "".concat(baseClass, "-has-placeholder-border"), featuredHeader && "".concat(baseClass, "-has-featured-header"), link && "".concat(baseClass, "-has-link"), overflow && "".concat(baseClass, "-has-overflow"), padded && "".concat(baseClass, "-padded"), selected && "".concat(baseClass, "-selected"), !children && "".concat(baseClass, "-empty"), className, placeholder && "".concat(baseClass, "-").concat(ratioClass), "".concat(baseClass, "-has-").concat(backgroundClassFragment, "-theme"));
    if (placeholderChild) {
        return React.cloneElement(placeholderChild, {
            className: cssClassNames
        });
    }
    if (childrenArray.length > 1) {
        return (React.createElement(Tag, __assign({ className: cssClassNames }, attributes, { ref: ref, style: style }),
            featuredHeader,
            newChildren,
            actionArea,
            link));
    }
    if (childrenArray.length === 1) {
        var firstChild = childrenArray[0];
        var cardCustomStyleProps = __assign(__assign({}, (_a = firstChild === null || firstChild === void 0 ? void 0 : firstChild.props) === null || _a === void 0 ? void 0 : _a.style), style);
        var decoratedChild = React.cloneElement(firstChild, __assign(__assign({ className: classNames(cssClassNames, (_b = firstChild === null || firstChild === void 0 ? void 0 : firstChild.props) === null || _b === void 0 ? void 0 : _b.className) }, attributes), (Object.keys(cardCustomStyleProps).length !== 0 && { style: cardCustomStyleProps })));
        return decoratedChild;
    }
    return React.createElement(Tag, __assign({ className: cssClassNames }, attributes, { ref: ref, style: style }));
});
UitkCard.displayName = 'UitkCard';
// Temporary, unstable
var UitkCardAloha = UitkCard;

export { UitkCard, UitkCardAloha };
